module.exports = __webpack_public_path__ + "img/黑马云音乐.3087f1a8.png";